// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"294":"5f68e3b5","315":"de95eab6","787":"4e01dc3d","923":"8a7e9d73"}[chunkId] + ".chunk.js";
};